/**
 * Parse a user-entered numeric string (allows commas / currency noise).
 * Returns NaN when empty or invalid — callers can treat that as 0 via the engine.
 */
export function parseNumericInput(value: string): number {
  const cleaned = value.replace(/[^0-9.-]/g, "").trim();
  if (!cleaned || cleaned === "-" || cleaned === "." || cleaned === "-.") {
    return Number.NaN;
  }
  return Number(cleaned);
}

export function parsePositiveNumber(value: string): number | null {
  const n = parseNumericInput(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n;
}
